module.exports = __webpack_public_path__ + "img/pCreditW.f7b73f12.svg";